import { useFormContext } from "react-hook-form";

import { FormTextField } from "@covertree/ui";

import { PersonalDetailsWithExtraQuestionsForm } from "../validatorsAndTypes/personalDetailsForm";

interface Props {
  name?: string;
  label?: React.ReactNode;
}

export function NumberOfVehiclesInput({
  name = "numberOfVehicles",
  label = "Number of vehicles",
}: Props) {
  const { control } = useFormContext<PersonalDetailsWithExtraQuestionsForm>();

  return (
    <FormTextField
      id="number-of-vehicles"
      dataTestId="number-of-vehicles-input"
      name={name}
      label={label}
      type="text"
      inputMode="numeric"
      control={control}
      nullOnEmpty
      optional
    />
  );
}
